export const ANALYTICS_EVENT_NAMES = {
    ADD_USER: "Add User",
    BILLING_NOTIFICATIONS_UPDATED: "Billing Notifications Updated",
    BULK_REMOVE_USERS: "Bulk Remove Users",
    BULK_REVOKE_USERS: "Bulk Revoke Users",
    CREATE_CUSTOM_GROUP: "Create Custom Group",
    CREATE_CUSTOM_ROLE: "Create Custom Role",
    CREATE_TEAM: "Create Team",
    DELETE_TEAM: "Delete Team",
    EDIT_TEAM: "Edit Team",
    GEN_AI_UPDATE: "Gen AI Update",
    GRANT_PERMISSIONS: "Grant Permissions",
    INSTANCE_DETAILS_UPDATED: "Instance Details Updated",
    REMOVE_USER: "Remove User",
    REVOKE_PERMISSIONS: "Revoke User",
    SESSION_LOGIN: "Authentication: Token Added",
    SESSION_RENEWED: "Authentication: Token Renewed",
    SUPPORT_ORG_ADD_ACCESS: "Support: Added to Organization",
    SUPPORT_SEARCH_USER_PERMISSIONS: "Support: Search User Permissions",
    UPDATE_GROUP_TYPE_FILTERS: "Update Group Type Filters",
    UPDATE_SSO_ORG_LOCAL_LOGIN_SETTING: "Enabled SSO Local Login for Organization",
    UPDATE_SSO_ORG_LOCAL_LOGIN_MFA_SETTING: "Enabled SSO Local Login MFA for Organization",
    UPDATE_LOCAL_LOGIN_FOR_USER: "Enabled SSO Local Login for User",
    VIEW_PRODUCT_USAGE_BILLING_DASHBOARD: "View Product Usage & Billing Dashboard"
};

export const ANALYTICS_TRACKED_COMPONENTS = {
    USER_SIDEBAR: "User Sidebar",
    USERS_TAB: "Users Tab",
    INVITATION_SIDEBAR: "Invitation Sidebar",
    UPDATE_GROUP_SIDEBAR: "Update Group Sidebar",
    CREATE_GROUP_SIDEBAR: "Create Group Sidebar",
    CREATE_CUSTOM_ROLE_SIDEBAR: "Create Custom Role Sidebar",
    GEN_AI_TAB: "Gen AI Tab",
    GROUPS_TAB: "Groups Tab",
    INSTANCE_DETAILS_PAGE: "Instance Details Page",
    SESSION: "Session",
    SSO_LOCAL_LOGIN_TAB: "SSO Local Login Tab",
    SUPPORT_ACCESS_SIDEBAR: "Organization Access Sidebar",
    TEAM_SIDEBAR: "Team Sidebar",
    TEAM_TABLE: "Teams Table",
    USER_TABLE: "User Table",
    USAGE_AND_BILLING_DASHBOARD: "Usage & Billing Dashboard",
    NOTIFICATION_RECIPIENTS_SHEET: "Notification Recipients Sheet"
} as const;

export const ANALYTICS_FLOWS = {
    USER_PAGE: "User Page",
    PRODUCT_ACCESS: "Product Access",
    GROUP_ACCESS: "Group Access",
    ROLES_PAGE: "Roles Page",
    LOGIN: "Login",
    SETTINGS: "Settings",
    SUPPORT: "Support Page",
    USERS: "Users",
    USAGE_AND_BILLING: "Usage & Billing",
    TEAMS: "Teams Page"
} as const;

export const ANALYTICS_PRODUCT_NAME = "Common Platform";
export const ANALYTICS_SUBPRODUCT_NAME = "Admin Center";
